'use strict';

wbApp.directive('wbRentHourStartTypeCombo', ['$timeout', '$translate',
    function ($timeout, $translate) {
        function formatResult(itemSelectionType) {
            if (!itemSelectionType) { return; }
            return $translate.instant(itemSelectionType.text);
        }

        function formatSelection(itemSelectionType) {
            return $translate.instant(itemSelectionType.text);
        }

        function shouldBeVisible(visibleSelection, id) {
            if (visibleSelection) {
                return visibleSelection.includes(id + '');
            }

            return true;
        }

        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                model: '=ngModel',
                visibleSelection: '=',
            },
            link: function (scope, elm, attrs, controller) {
                $timeout(function () {
                    $(elm).select2({
                        formatResult: formatResult,
                        formatSelection: formatSelection,
                        dropdownAutoWidth: true,
                        allowClear: false,
                        minimumResultsForSearch: -1,
                        data: [
                            { id: 0, text: 'TXT_RENT_HOUR_START_TYPE_AT_ANY_TIME', disabled: scope.disabledSelection === 0 },
                            { id: 1, text: 'TXT_RENT_HOUR_START_TYPE_AT_WHOLE_HOUR_ONLY', disabled: scope.disabledSelection === 1 },
                            { id: 2, text: 'TXT_RENT_HOUR_START_TYPE_AT_HALF_HOUR_ONLY', disabled: scope.disabledSelection === 2 },
                            { id: 3, text: 'TXT_RENT_HOUR_START_TYPE_AT_HALF_OR_FULL_HOUR', disabled: scope.disabledSelection === 3 },
                        ]
                    });

                    controller.$render = function () {
                        elm.select2('val', controller.$viewValue);
                    };

                    controller.$parsers.unshift(function (viewValue) {
                        if (!viewValue) {
                            return 0;
                        } else {
                            return parseInt(viewValue);
                        }
                    });

                    controller.$formatters.unshift(function (value) {
                        if (!value) {
                            return "0";
                        } else {
                            return value + "";
                        }
                    });

                    elm.on('change', function () {
                        scope.$apply(function () {
                            controller.$setViewValue(elm.select2('val'));
                        });
                    });

                    attrs.$observe('disabled', function (value) {
                        elm.select2('enable', !value);
                    });

                    attrs.$observe('readonly', function (value) {
                        elm.select2('readonly', !!value);
                    });

                    elm.bind("$destroy", function () {
                        elm.select2("destroy");
                    });

                }, 1);
            }
        }
    }]);